<script setup lang="ts">
import { routenames } from '@/router/routenames';
import { useAuthenticationStore } from '@/stores/authenticationStore';
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const router = useRouter();
const authenticationStore = useAuthenticationStore();

const route = useRoute();

// only onMounted we can be sure, that the old view is completely unmounted
// and we might need this for unregistering stuff
onMounted(async () => {
  await authenticationStore.signOut();

  const fromRoute = router.options.history.state.back
    ? router.resolve({
        path: String(router.options.history.state.back),
      })
    : route.redirectedFrom;

  const url = router.resolve({
    name: routenames.signIn,
    hash: route.hash,
    params: route.params,
    query: {
      ...route.query,
      // this is needed in the SignInView to know where we are coming from
      from: fromRoute?.name === routenames.notFound ? undefined : fromRoute?.fullPath,
    },
  }).href;

  window.location.replace(url);
});
</script>
<script lang="ts">
export default {
  render() {
    return null;
  },
};
</script>
